import { render, staticRenderFns } from "./MapLegend.vue?vue&type=template&id=38c7fbc6&scoped=true"
import script from "./MapLegend.vue?vue&type=script&lang=ts"
export * from "./MapLegend.vue?vue&type=script&lang=ts"
import style0 from "./MapLegend.vue?vue&type=style&index=0&id=38c7fbc6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c7fbc6",
  null
  
)

export default component.exports